import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CollapsibleBlock from "src/components/CollapsibleBlock/CollapsibleBlock";
import AttachmentsSelector from "src/components/AttachmentsSelector/AttachmentsSelector";
import useCollapsibles, {
  ERecurringTransactionMobileCollapsibles,
} from "src/hooks/useCollapsibles";
import useMobile from "src/hooks/useMobile";
import useCurrentUser from "src/hooks/useCurrentUser";
import useLocalStorageState from "use-local-storage-state";

export enum EAttachmentsTableViewStyle {
  TABLE = "table",
  GRID = "grid",
}

interface IRecurringTransactionAttachments {
  attachments: Array<any>;
  onChange: (data: any) => void;
  onClick: (data: any) => void;
}

const ATTACHMENTS_KEY = "attachments-table";
const DEFAULTS: {
  tableStyle: EAttachmentsTableViewStyle;
} = {
  tableStyle: EAttachmentsTableViewStyle.GRID,
};

const RecurringTransactionAttachments: React.FC<
  IRecurringTransactionAttachments
> = ({ attachments, onChange, onClick }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const [totalFiles, setTotalFiles] = useState<number>(0);
  const [unsavedAttachments, setUnsavedAttachments] = useState<any[]>([]);
  const { userInfo } = useCurrentUser();
  const [attachmentsTableStyle, setAttachmentsTableStyle] =
    useLocalStorageState(`${userInfo?._id}-${ATTACHMENTS_KEY}`, {
      defaultValue: DEFAULTS,
    });

  useEffect(() => {
    setTotalFiles(unsavedAttachments?.length + attachments?.length);
  }, [unsavedAttachments, attachments]);

  const {
    isRecurringTransactionMobileCollapsibleOpen,
    toggleRecurringTransactionMobileCollapsible,
    collapsiblePreferences,
    updateCollapsible,
  } = useCollapsibles();

  return (
    <CollapsibleBlock
      keepAlive
      title={t("register_payment_modal.collapsibles.files.title")}
      badge={
        totalFiles
          ? t("register_payment_modal.collapsibles.files.count", {
              count: totalFiles,
            })
          : t("register_payment_modal.collapsibles.files.no_attachments")
      }
      open={
        isMobile
          ? isRecurringTransactionMobileCollapsibleOpen(
              ERecurringTransactionMobileCollapsibles.ATTACHMENTS
            )
          : collapsiblePreferences.recurringTransactionAttachmentsOpen
      }
      onChange={(isOpen: boolean) => {
        if (isMobile) {
          toggleRecurringTransactionMobileCollapsible(
            ERecurringTransactionMobileCollapsibles.ATTACHMENTS
          );
        } else {
          updateCollapsible({ recurringTransactionAttachmentsOpen: isOpen });
        }
      }}
      uppercase
    >
      <>
        <AttachmentsSelector
          savedAttachments={attachments}
          onChange={(data: any) => {
            setUnsavedAttachments(data?.unsaved);
            onChange(data);
          }}
          onClick={(data: any) => onClick(data)}
        />
      </>
    </CollapsibleBlock>
  );
};

export default RecurringTransactionAttachments;
